import React from 'react';

import createStyle from 'shared-utils/src/createStyle';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

export default ({ forceHeight = false, children }) => {
  const cls = useStyles();
  return (
    <div className={`${cls[mainCls]}${forceHeight ? ' force-height' : ''} c-bg--w`}>
      {children}
    </div>
  );
};

